import React from "react";
import "./styles.css";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';

const PhotoCarousel = () => {
const images = [
  { src: "/assets/images/article1.png", alt: "1" },
  { src: "/assets/images/article3.png", alt: "2" },
  { src: "/assets/images/article2.png", alt: "3" },
  { src: "/assets/images/article4.png", alt: "4" },
];


  return (
    <Swiper
      modules={[Navigation, Pagination, Autoplay]}
      spaceBetween={10}
      slidesPerView={1}
      navigation
      pagination={{ clickable: true }}
      autoplay={{ delay: 10000 }}
    >
      {images.map((image, index) => (
        <SwiperSlide key={index}>
          <img src={image.src} alt={image.alt} className="carousel-image" />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default PhotoCarousel;
